module.exports = __webpack_public_path__ + "img/logo_special-oly-world-games.581dc06c.png";